import { Fragment, type ReactNode } from 'react'

/**
 * A translated sentence with markup inside it: „ცვლის PIN არის {cashier} PIN"
 * where {cashier} is a <strong>. Word order differs between languages, so the
 * markup travels as a placeholder instead of the sentence being cut in two
 * around it. Placeholders not named in `parts` stay as they are.
 */
export function rich(text: string, parts: Record<string, ReactNode>): ReactNode {
  const out: ReactNode[] = []
  let last = 0
  for (const m of text.matchAll(/\{(\w+)\}/g)) {
    if (!(m[1] in parts)) continue
    const at = m.index ?? 0
    if (at > last) out.push(text.slice(last, at))
    out.push(<Fragment key={out.length}>{parts[m[1]]}</Fragment>)
    last = at + m[0].length
  }
  if (last < text.length) out.push(text.slice(last))
  return out
}
